import React, { useState } from "react"
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import DialogActions from "@mui/material/DialogActions"
import DialogTitle from "@mui/material/DialogTitle"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Tablero from '../../forms/Configuracion/Tableros'
import Usuarios from '../../forms/Seguridades/Usuarios'
import Roles from '../../forms/Seguridades/Roles'
import Areas from '../../forms/Configuracion/Areas'
import Empresas from '../../forms/Configuracion/Empresas'
import Grupos from '../../forms/Configuracion/Grupos'
import UsuariosConfig from "../../forms/Configuracion/UsuariosConfig"
import RolesBI from '../../forms/SeguridadesBI/RolesBI'

export default function FormModal(props) {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [currentFormEvent, setCurrentFormEvent] = useState(null)

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
      marginTop: 0,
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(2),
      justifyContent: 'center',
      borderTop: 'none',
      marginBottom: theme.spacing(2),
    },
    '& .MuiDialogTitle-root': {
      textAlign: 'center',
      padding: theme.spacing(2),
      borderBottom: 'none',
      marginTop: theme.spacing(4),
    },
    borderRadius: '12px',
  }))

  const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: 8,
    top: 8,
    backgroundColor: 'lightblue',
    color: 'blue',
    borderRadius: 10,
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'lightblue',
    },
  }))

  const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '20px',
    marginLeft: theme.spacing(4),
    padding: theme.spacing(1, 4),
  }))

  const formComponents = {
    tablero: Tablero,
    areas: Areas,
    usuarios: Usuarios,
    roles: Roles,
    empresas: Empresas,
    usuariosConfig: UsuariosConfig,
    grupo: Grupos,
    rolesBI: RolesBI
  }

  const SelectedFormComponent = formComponents[props.opt]

  const handleSaveClick = (e) => {
    e.preventDefault()
    setCurrentFormEvent(e)  // Guardamos el evento para pasarlo luego
    setConfirmOpen(true) // Solo abrir el modal de confirmación
  }

  const handleConfirmSave = () => {
    setConfirmOpen(false)
    if (currentFormEvent) {
      props.handledSave(currentFormEvent)  // Llamamos a handledSave con el evento almacenado
    }
  }

  const handleCancelSave = () => {
    setConfirmOpen(false)
  }

  return (
    <>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            props.handleCloseModal()
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
        maxWidth={props.modalWith}
        fullWidth={true}
        disableEscapeKeyDown={true}
      >
        <DialogTitle id="customized-dialog-title">
          {props.header}
        </DialogTitle>
        <CloseButton
          aria-label="close"
          onClick={props.handleCloseModal}
        >
          <CloseIcon />
        </CloseButton>
        <form action="/" method="POST" onSubmit={handleSaveClick}>
          <DialogContent dividers={false} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            {SelectedFormComponent && <SelectedFormComponent formData={props.formData} editRoles={props.editRoles} />}
          </DialogContent>
          {
            (props.opt !== 'roles' && props.opt !== 'rolesBI' && props.opt !== 'usuarios') && (
              <DialogActions>
                <StyledButton type="submit" sx={{ backgroundColor: 'blue', color: 'white', '&:hover': { backgroundColor: 'darkblue' } }}>
                  Guardar
                </StyledButton>
                <StyledButton onClick={props.handleCloseModal} sx={{ backgroundColor: 'lightblue', color: 'blue', '&:hover': { backgroundColor: 'lightblue' } }}>
                  Cancelar
                </StyledButton>
              </DialogActions>
            )
          }
          {
            (props.opt === 'usuarios' && props.editRoles === 'usuarios') && (
              <DialogActions>
                <StyledButton type="submit" sx={{ backgroundColor: 'blue', color: 'white', '&:hover': { backgroundColor: 'darkblue' } }}>
                  Guardar
                </StyledButton>
                <StyledButton onClick={props.handleCloseModal} sx={{ backgroundColor: 'lightblue', color: 'blue', '&:hover': { backgroundColor: 'lightblue' } }}>
                  Cancelar
                </StyledButton>
              </DialogActions>
            )
          }
        </form>
      </BootstrapDialog>

      <Dialog open={confirmOpen} onClose={handleCancelSave}>
        <DialogTitle>Confirmar Acción</DialogTitle>
        <DialogContent>
          <p>¿Estás seguro de que deseas guardar/editar la información?</p>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={handleCancelSave} sx={{ backgroundColor: 'lightblue', color: 'blue', '&:hover': { backgroundColor: 'lightblue' } }}>
            Cancelar
          </StyledButton>
          <StyledButton onClick={handleConfirmSave} sx={{ backgroundColor: 'blue', color: 'white', '&:hover': { backgroundColor: 'darkblue' } }}>
            Confirmar
          </StyledButton>
        </DialogActions>
      </Dialog>
    </>
  )
}
